import Ajv from 'ajv';

/**
 * Validates prediction data against a JSON schema
 * @param prediction - The prediction data to validate
 * @param jsonSchema - The JSON schema to validate against
 * @returns Object with isValid flag and optional error message
 */
export function validatePrediction(
  prediction: Record<string, unknown>,
  jsonSchema: Record<string, any>
): { isValid: boolean; error: string | null } {
  try {
    const ajv = new Ajv({
      allErrors: true,
      strictSchema: false,
    });
    const validate = ajv.compile(jsonSchema);
    const isValid = validate(prediction);

    if (!isValid && validate.errors) {
      // Format validation errors into a readable message
      const errorMessages = validate.errors
        .map((err) => {
          const path = err.instancePath || err.schemaPath || '';
          return `${path} ${err.message}`;
        })
        .join('; ');
      return {
        isValid: false,
        error: `Validation failed: ${errorMessages}`,
      };
    }

    return { isValid: true, error: null };
  } catch (error) {
    return {
      isValid: false,
      error: error instanceof Error ? error.message : 'Unknown validation error',
    };
  }
}
